import Alert from "@mui/material/Alert";

import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import Typography from "@mui/material/Typography";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import {ReactComponent as ExpandMoreIcon} from "../../icons/ExpandMore24.svg";
import isEmpty from "lodash-es/isEmpty";

const AddStudentResultDialog = ({ onClose, open, successes, fails }) => {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          maxWidth: 450,
          maxHeight: 700,
        },
      }}
      onClose={handleClose}
      open={open}
      fullScreen={true}
    >
      <DialogTitle id="select-student-list-dialog-title">
        Adding Student(s) Results
      </DialogTitle>

      <DialogContent>
        <Alert severity="info" sx={{ mt: 1 }}>
          Click on the Added/Not Added bars to see details.
        </Alert>

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }}>
          <AccordionSummary
            sx={{ backgroundColor: "rgb(237,247,237)" }}
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography fontWeight={700}>Added ({successes.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Table aria-label="students added" size="small">
              <TableBody>
                {successes.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={10}>-- NO STUDENTS ADDED --</TableCell>
                  </TableRow>
                )}
                {successes.map((student) => (
                  <TableRow>
                    {student.last_name}, {student.first_name}
                    {isEmpty(student.mi) === false && <> {student.mi}.</>}
                    {!isEmpty(student.message) && (
                      <>
                        <br />
                        <i>{student.message}</i>
                      </>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </AccordionDetails>
        </Accordion>

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }}>
          <AccordionSummary
            sx={{ backgroundColor: "rgb(253, 137, 137)" }}
            expandIcon={<ExpandMoreIcon />}
          >
            <Typography fontWeight={700}>Not Added ({fails.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {fails.length === 0 && (
              <TableRow>
                <TableCell colSpan={10}>-- NO STUDENTS FAILED --</TableCell>
              </TableRow>
            )}
            {fails.map((student) => (
              <TableRow>
                {student.last_name}, {student.first_name}
                <br />
                {isEmpty(student.mi) === false && <> {student.mi}.</>}
                <i>{student.message}</i>
              </TableRow>
            ))}
          </AccordionDetails>
        </Accordion>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="outlined">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddStudentResultDialog;
